import { bowser, view } from '@yola/ws-sdk';
import highlighterOffset from 'src/js/modules/highlighter/helpers/highlighter-offset';

const calculateOffsetTop = (element, top, options = {}) => {
  if (!bowser.iPadOS) return top;

  /**
   * Workaround for iPadOS to calculate
   * element offset properly
   */
  const { align = 'bottom' } = options;
  const indent = highlighterOffset.get();
  const { height } = element.getBoundingClientRect();
  const elementOffset = view.accessors.getElementOffset(element);

  if (align === 'center') {
    return elementOffset + height / 2;
  }

  return elementOffset + height + indent;
};

export default calculateOffsetTop;
